import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Icon, Tooltip } from 'antd';
import classNames from 'classnames';

import editDocumentActions from '../store/actions/edit-document.actions';
import documentEditMode from '../constants/documentEditMode';

import { ReactComponent as VisibleCompanyIcon } from '../../../resource/documents/VisibleCompanyIcon.svg';
import { ReactComponent as VisibleMembersIcon } from '../../../resource/documents/VisibleMembersIcon.svg';

import styles from './table.module.scss';

const getVisibilityIcon = (visibility) => {
  const visibilityName = visibility?.name;

  const defaultProps = {
    className: classNames(styles.icon, styles.visibilityIcon),
  };

  switch (visibilityName) {
    case 'Компания':
      return (
        <Icon
          {...defaultProps}
          component={VisibleCompanyIcon}
        />
      );
    case 'Участники':
      return (
        <Icon
          {...defaultProps}
          component={VisibleMembersIcon}
        />
      );
    default:
      return (
        <Icon
          {...defaultProps}
          type="eye"
        />
      );
  }
};

export const ExpandedRowDocVisibility = ({ record }) => {
  const dispatch = useDispatch();

  const listDocumentVisibility = useSelector(
    (store) => store.newDocumentStore.listDocumentVisibility
  );

  const curVisibility = (listDocumentVisibility || []).find(
    (docVis) => docVis.id === record.documentVisibility
  );

  return (
    <Tooltip
      title={`Видимость: ${curVisibility?.name || 'Не установлена'}`}
      placement="right"
    >
      <Button
        ghost
        shape="circle"
        onClick={(e) => {
          e.stopPropagation();
          dispatch(
            editDocumentActions.openModal({
              ...record,
              editMode: documentEditMode.VISIBILITY,
            })
          );
        }}
      >
        {getVisibilityIcon(curVisibility)}
      </Button>
    </Tooltip>
  );
};

ExpandedRowDocVisibility.propTypes = {
  record: PropTypes.object.isRequired,
};
